export default {"src":"/_next/static/media/search_bold.10eb2ac2.svg","height":24,"width":24};